// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CoursePracticeProgress
 */
export interface CoursePracticeProgress {
    /**
     * 
     * @type {string}
     * @memberof CoursePracticeProgress
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CoursePracticeProgress
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CoursePracticeProgress
     */
    passId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CoursePracticeProgress
     */
    passedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CoursePracticeProgress
     */
    status?: CoursePracticeProgressStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CoursePracticeProgressStatusEnum {
    Passed = 'passed',
    NotPassed = 'not_passed',
    Waiting = 'waiting',
    SendToRevision = 'send_to_revision'
}



